//config
export * from './customers-config'

export * from './lib/customers-list/customers-list'
export * from './lib/customers-detail/customers-detail'
export * from './components/icon-alert/icon-alert'
export * from './components/chip-listino/chip-listino'
export * from './components/dialog-components/customers-filter-dialog-component/customers-filter-dialog-component'
export * from './interfaces/customers-filter'
export * from './interfaces/customers-filter-dialog-data'
export * from './interfaces/lookup-tables/zone.model'
export * from './services/lookup-tables/agenti.service'
export * from './services/lookup-tables/ispettori.service'
export * from './services/lookup-tables/tipo-zona.service'
export * from './services/lookup-tables/zone.service'
export * from './components/bt-sheet-components/customers-notifications-bottom-sheet/customers-notifications-bottom-sheet'
export * from './components/dialog-components/customer-details/customers-add-contact-dialog-component/customers-add-contact-dialog-component'
export * from './components/dialog-components/customer-details/customers-address-details-dialog-component/customers-address-details-dialog-component'
export * from './interfaces/customer-contacts.model'
export * from './interfaces/customer-notification.model'
export * from './services/customer-detail.service'
export * from './interfaces/customer-detail.model'
export * from './interfaces/deliveryDestionations.model'
